import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'We are sorry the article was not helpful. Will you let us know what was wrong?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'The information I am looking for is missing',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'There are factual errors',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Some issues are unclear',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Give us some background and we\'ll improve this article.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Send'
    }
  }
};
